<template>
  <div class="">
    <div class="label-standard">{{ label }}</div>
    <div class="form-line">
      <input type="password" class="input-standard"
        :value="value"
        v-on:blur="updateValue({
          key       : propertyKey,
          value     : $event.target.value,
          objectType: objectType
        })" />
    </div>
  </div>
</template>

<script>
  export default {
    props : {
      label : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type    : Function,
        required: false
      },

      value : {
        type    : String,
        required: false
      },

      objectType : {
        type    : String,
        required: false
      },

    },
  }
</script>